import {createContext} from 'react'

const ValesContext = createContext()

export default ValesContext